import Image from "components/atoms/Image";
import Text from "components/atoms/Text";
import Grid, { GridCol, GridRow } from "components/organisms/Grid";
import { BASE_URL } from "constants/env";
import React from "react";
import { mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

type Types = "imageLeft" | "imageRight" | "imageTop" | "imageBottom";
interface CardSectionProps {
  title: string;
  description: string;
  imgSrc: string;
  reverse?: boolean;
  modifiers?: Types;
}

const CardSection = React.forwardRef<HTMLDivElement, CardSectionProps>(
  ({ title, description, imgSrc, reverse, modifiers }, ref) => (
    <div className={mapMultiClassnames("m-cardSection", modifiers)} ref={ref}>
      <Grid>
        {reverse ? (
          <GridRow>
            <GridCol colMd={6} order={2}>
              <div className="m-cardSection_title">
                <Text size="lg">{title}</Text>
              </div>
              <label
                dangerouslySetInnerHTML={{
                  __html: description || "",
                }}
              />
              {/* <Text modifiers={["gray"]}>{description}</Text> */}
            </GridCol>
            <GridCol colMd={6} order={1}>
              <div className="m-cardSection_img">
                {imgSrc && <Image src={`${BASE_URL}${imgSrc}`} alt={title} />}
              </div>
            </GridCol>
          </GridRow>
        ) : (
          <GridRow>
            <GridCol colMd={6} order={1}>
              <div className="m-cardSection_title">
                <Text size="lg">{title}</Text>
              </div>
              <label
                dangerouslySetInnerHTML={{
                  __html: description || "",
                }}
              />
            </GridCol>
            <GridCol colMd={6} order={2}>
              <div className="m-cardSection_img">
                {imgSrc && <Image src={`${BASE_URL}${imgSrc}`} alt={title} />}
              </div>
            </GridCol>
          </GridRow>
        )}
      </Grid>
    </div>
  ),
);

export default CardSection;
